import { HttpClient } from '../common/clients/http-client/http.client';
import { REACT_APP_API_HOST } from '../.env';
import HttpClientFetchAdapter from '../common/clients/http-client/http-client-fetch.adapter';
import ShipClient from '../common/clients/ship.client';

// #region Clients
let httpClient: HttpClient;
export const getHttpClient = (): HttpClient => {
  if (httpClient) {
    return httpClient;
  }

  httpClient = new HttpClient({
    adapter: new HttpClientFetchAdapter(),
  });

  return httpClient;
};

let shipClient: ShipClient;
export const getShipClient = (): ShipClient => {
  if (shipClient) {
    return shipClient;
  }

  shipClient = new ShipClient({
    host: REACT_APP_API_HOST,
    httpClient: getHttpClient(),
  });

  return shipClient;
};
// #endregion Clients
